<wvr-card-component [themeVariant]="themeVariant" [panelFormat]="panelFormat" [selectorPrefix]="'tl'" [collapseMethod]="collapseMethod" [startCollapsed]="startCollapsed" [collapsed]="collapsed">
  <ng-content select="template" ngProjectAs="template"></ng-content>
</wvr-card-component>
